export function showalert(message, alerttype) {
  document.getElementById(
    "alert_placeholder"
  ).innerHTML = `<div id="alertdiv" class="alert alert-${alerttype} fw-bolder text-center">${message}</div>`;

  setTimeout(function () {
    document.getElementById("alertdiv").style.display = "none";
  }, 2000);
}
